import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import { Card, CardHeader, CardContent, IconButton, Button, Modal, Stack, TextField, Typography, FormControl, OutlinedInput, InputLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { splitTransactionAction } from '../../../services/request';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const NumberField = ({ value, handleChange, handleBlur }) => (
  <FormControl sx={{ flex: 0.3 }}>
    <InputLabel htmlFor="number-field">Kwota</InputLabel>
    <OutlinedInput
      id="number-field"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      label="Kwota"
      type="number"
    />
  </FormControl>
);

const EditTransaction = ({ open, handleClose, transaction, setTransactions, collect }) => {
  const [totalAmount, setTotalAmount] = React.useState(collect ? parseFloat(transaction.amount).toFixed(2) : parseFloat(transaction.amount.amount).toFixed(2));
  const { mutate, loading } = useMutation(splitTransactionAction);

  const [title1, setTitle1] = React.useState(transaction.title);
  const [title2, setTitle2] = React.useState(transaction.title);

  const [amount1, setAmount1] = React.useState('0.00');
  const [amount2, setAmount2] = React.useState('0.00');


  const handleChangeTitle1 = e => setTitle1(e.target.value);
  const handleChangeTitle2 = e => setTitle2(e.target.value);

  const handleChangeAmount1 = e => {
    const totalAmountAvailableNumber = Number(totalAmount) - Number(parseFloat(amount2).toFixed(2));
    const targetValueNumber = Number(parseFloat(e.target.value).toFixed(2));

    if (_.isNaN(targetValueNumber) || targetValueNumber < 0) {
      setAmount1('');
    } else if (totalAmountAvailableNumber >= targetValueNumber) {
      setAmount1(targetValueNumber);
    }

  };
  const handleChangeAmount2 = e => {
    const totalAmountAvailableNumber = Number(totalAmount) - Number(parseFloat(amount1).toFixed(2));
    const targetValueNumber = Number(parseFloat(e.target.value).toFixed(2));

    if (_.isNaN(targetValueNumber) || targetValueNumber < 0) {
      setAmount2('');
    } else if (totalAmountAvailableNumber >= targetValueNumber) {
      setAmount2(targetValueNumber);
    }
  };

  const handleBlurAmount1 = e => {
    if (e.target.value.trim() === '') {
      setAmount1('0.00');
    }
  };

  const handleBlurAmount2 = e => {
    if (e.target.value.trim() === '') {
      setAmount2('0.00');
    }
  };

  const calculateRemainingAmount = () => {
    const currentAmount1 = Number(parseFloat(amount1).toFixed(2)) || 0;
    const currentAmount2 = Number(parseFloat(amount2).toFixed(2)) || 0;

    return Number(totalAmount) - currentAmount1 - currentAmount2;
  };

  const handleClick = async () => {
    if (calculateRemainingAmount() === 0) {
      const { payload, error } = await mutate(transaction.id, {
        'split1': { ...transaction, title: title1, amount: amount1 },
        'split2': { ...transaction, title: title2, amount: amount2 }
      });
      if (!error) {
        setTransactions(prev => prev.filter(t => t.id !== transaction.id));
        setTransactions(prev => [
          ...prev,
          ...payload
        ]);
        handleClose();
      }
    } else {
      toast.error('Pozostała kwota musi być równa 0');
    }

  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style, width: '80vw' }}>
        <CardHeader
          title="Rozdziel transakcje"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent>
          <Stack spacing={4}>
            <Typography align="center" variant="h3">Pozostała kwota: {calculateRemainingAmount()} {transaction.amount.currency}</Typography>
            <Stack direction="row" spacing={2}>
              <NumberField
                value={amount1}
                handleChange={handleChangeAmount1}
                handleBlur={handleBlurAmount1}
              />
              <TextField
                label="Data"

                disabled
                value={transaction.entry_date}
              />
              <TextField
                label="Kontrahent"
                disabled
                value={transaction.contractor}
              />
              <TextField
                label="Tytuł"
                value={title1}
                onChange={handleChangeTitle1}
                sx={{ flex: 1 }}
              />
            </Stack>
            <Stack direction="row" spacing={2}>
              <NumberField
                value={amount2}
                handleChange={handleChangeAmount2}
                handleBlur={handleBlurAmount2}
              />
              <TextField
                label="Data"

                disabled
                value={transaction.entry_date}
              />
              <TextField
                label="Kontrahent"
                disabled
                value={transaction.contractor}
              />
              <TextField
                label="Tytuł"
                value={title2}
                onChange={handleChangeTitle2}
                sx={{ flex: 1 }}
              />
            </Stack>
            <Button variant="contained" onClick={handleClick}>Rozdziel</Button>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default EditTransaction;

